import { Routes } from '@angular/router';
import { eventDetailResolver } from './resolvers/event-detail.resolver';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./layout/presentation.component').then((m) => m.PresentationComponent),
    children: [
      {
        path: 'home',
        loadComponent: () => import('./pages/home/home.component').then((m) => m.HomeComponent),
      },
      {
        path: 'about',
        loadComponent: () => import('./pages/about/about.component').then((m) => m.AboutComponent),
      },
      {
        path: 'events',
        loadComponent: () => import('./pages/events/events.component').then((m) => m.EventsPageComponent),
      },
      {
        path: 'event/:slug',
        loadComponent: () => import('./pages/event/event.component').then((m) => m.EventComponent),
        resolve: { event: eventDetailResolver },
      },
      {
        path: 'gallery',
        loadComponent: () => import('./pages/gallery/gallery.component').then((m) => m.GalleryComponent),
      },
      {
        path: 'gallery/id/:id',
        loadComponent: () => import('./pages/album-detail/album-detail.component').then((m) => m.AlbumDetailComponent),
      },
      {
        path: 'gallery/:slug',
        loadComponent: () => import('./pages/album-detail/album-detail.component').then((m) => m.AlbumDetailComponent),
      },
      {
        path: 'membership-program',
        loadComponent: () =>
          import('./pages/membership-program/membership-program.component').then((m) => m.MembershipProgramComponent),
      },
      {
        path: 'booking',
        loadComponent: () => import('./pages/booking/booking.component').then((m) => m.BookingComponent),
      },
      {
        path: 'linktree',
        loadComponent: () => import('./pages/linktree/linktree.component').then((m) => m.LinktreeComponent),
      },
      {
        path: 'support',
        loadComponent: () => import('./pages/support/support.component').then((m) => m.SupportComponent),
      },
      {
        path: 'not-found',
        loadComponent: () => import('./pages/not-found/not-found-page.component').then((m) => m.NotFoundPageComponent),
      },
      {
        path: 'error',
        loadComponent: () => import('./pages/error/error-page.component').then((m) => m.ErrorPageComponent),
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home',
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];
